import type { TranslateDictionary } from './en.js';

export const Da: TranslateDictionary = {
  'Start airplay': 'Start AirPlay',
  'Stop airplay': 'Stop AirPlay',
  Audio: 'Lyd',
  Captions: 'Undertekster',
  'Enable captions': 'Slå undertekster til',
  'Disable captions': 'Slå undertekster fra',
  'Start casting': 'Start casting',
  'Stop casting': 'Stop casting',
  'Casting to {device}': 'Caster til {device}',
  'Enter fullscreen mode': 'Slå fuldskærm til',
  'Exit fullscreen mode': 'Slå fuldskærm fra',
  Mute: 'Slå lyden fra',
  Unmute: 'Slå lyden til',
  'Enter picture in picture mode': 'Aktivér billede-i-billede-tilstand',
  'Exit picture in picture mode': 'Afslut billede-i-billede-tilstand',
  Play: 'Afspil',
  Pause: 'Pause',
  'Playback rate': 'Afspilningshastighed',
  'Playback rate {playbackRate}': 'Afspilningshastighed {playbackRate}',
  Quality: 'Kvalitet',
  'Seek backward': 'Spol tilbage',
  'Seek forward': 'Spol frem',
  Settings: 'Indstillinger',
  Auto: 'Auto',
  'audio player': 'lydafspiller',
  'video player': 'videoafspiller',
  volume: 'Lydstyrke',
  seek: 'Søg',
  'closed captions': 'Undertekster',
  'current playback rate': 'nuværende afspilningshastighed',
  'playback time': 'afspilningstid',
  'media loading': 'indlæser medier',
  settings: 'Indstillinger',
  'audio tracks': 'lydspor',
  quality: 'Kvalitet',
  play: 'afspil',
  pause: 'pause',
  mute: 'slå lyden fra',
  unmute: 'slå lyden til',
  'chapter: {chapterName}': 'kapitel: {chapterName}',
  live: 'live',
  Off: 'Fra',
  'start airplay': 'start AirPlay',
  'stop airplay': 'stop AirPlay',
  'start casting': 'start casting',
  'stop casting': 'stop casting',
  'enter fullscreen mode': 'slå fuldskærm til',
  'exit fullscreen mode': 'slå fuldskærm fra',
  'enter picture in picture mode': 'aktivér billede-i-billede-tilstand',
  'exit picture in picture mode': 'afslut billede-i-billede-tilstand',
  'seek to live': 'gå til live',
  'playing live': 'afspiller live',
  'seek back {seekOffset} seconds': 'spol tilbage {seekOffset} sekunder',
  'seek forward {seekOffset} seconds': 'spol frem {seekOffset} sekunder',
  'Network Error': 'Netværksfejl',
  'Decode Error': 'Afkodningsfejl',
  'Source Not Supported': 'Kilde ikke understøttet',
  'Encryption Error': 'Krypteringsfejl',
  'A network error caused the media download to fail.':
    'En netværksfejl forårsagede, at mediedownloaden mislykkedes.',
  'A media error caused playback to be aborted. The media could be corrupt or your browser does not support this format.':
    'En mediefejl forårsagede, at afspilningen blev afbrudt. Mediet kan være beskadiget, eller din browser understøtter ikke dette format.',
  'An unsupported error occurred. The server or network failed, or your browser does not support this format.':
    'Der opstod en ikke-understøttet fejl. Serveren eller netværket fejlede, eller din browser understøtter ikke dette format.',
  'The media is encrypted and there are no keys to decrypt it.':
    'Mediet er krypteret, og der er ingen nøgler til at dekryptere det.',
  'This video is not available.': 'Denne video er ikke tilgængelig.',
  'This video could not be found.': 'Videoen blev ikke fundet.',
};
